import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DriverGroupDto } from '@cargovibe/shared-types';
import { useCreateDriverGroup } from '@/modules/driver-groups/hooks/useDriverGroups';
import { getDriverGroupNameError } from '@/modules/driver-groups/getDriverGroupNameError';
import { submitCreateDriverGroup } from '@/modules/driver-groups/effects/submitCreateDriverGroup';

interface CreateDriverGroupForm {
  name: string;
  errorMessage: string;
  isPending: boolean;
  handleNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSave: () => void;
}

export function useCreateDriverGroupForm(
  onCreated: (group: DriverGroupDto) => void
): CreateDriverGroupForm {
  const { t } = useTranslation();
  const [name, setName] = useState<string>('');
  const [validationError, setValidationError] = useState<string>('');
  const createMutation: ReturnType<typeof useCreateDriverGroup> = useCreateDriverGroup();

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setName(event.target.value);
    setValidationError('');
    createMutation.reset();
  };

  const handleSave = (): void => {
    submitCreateDriverGroup({
      name,
      emptyNameMessage: t('driverGroups.errGroupName'),
      createDriverGroup: createMutation.mutate,
      setName,
      setValidationError,
      onCreated,
    });
  };

  return {
    name,
    errorMessage: validationError || getDriverGroupNameError(createMutation.error, t),
    isPending: createMutation.isPending,
    handleNameChange,
    handleSave,
  };
}
